"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IcdCodeQuestion = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _IcdCodeSearch = require("./IcdCodeSearch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var IcdCodeQuestion = function IcdCodeQuestion(_ref) {
  var required = _ref.required,
    answer = _ref.answer,
    form = _ref.form,
    disabled = _ref.disabled,
    name = _ref.name,
    defaultValue = _ref.defaultValue;
  var htmlId = (0, _utils.useUniqueHtmlId)();
  var fieldName = name || '';
  var control = /*#__PURE__*/_react.default.createElement(_IcdCodeSearch.IcdCodeSearch, {
    id: htmlId,
    disabled: disabled,
    form: form
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: htmlId,
    className: "mb-[8px] block"
  }, "ICD Codes"), form ? form.getFieldDecorator(fieldName, {
    rules: [{
      required: required,
      message: 'Answer is required'
    }],
    initialValue: defaultValue || (answer === null || answer === void 0 ? void 0 : answer.answerIds)
  })(control) : control);
};
exports.IcdCodeQuestion = IcdCodeQuestion;